<campus-svg class="ui-svg-background__image" [svgImage]="svgKey" [triggerRerenderBy]="triggerRerenderBy"></campus-svg>
